module.exports = __webpack_public_path__ + "img/notheader.a6b0426f.png";